import store from './store'
import api from './helpers/ApiHelper'
import config from './config';

const options = { 'offline': false, webClientId: config.webClientId }

// authentification
function login(device) {
    console.log('login device', device)
    store.commit("setAuthLoading", true);
    window.plugins.googleplus.login(
        options,
        function (obj) {
            _loginEndSuccess('login', obj, device)
        },
        function (msg) {
            _loginEndError('login', msg, device)
        }
    );
}

// authentification passive
function silentLogin(device) {
    console.log('silentLogin device', device)
    store.commit("setAuthLoading", true);
    window.plugins.googleplus.trySilentLogin(
        options,
        function (obj) {
            _loginEndSuccess('silentLogin', obj, device)
        },
        function (msg) {
            _loginEndError('silentLogin', msg, device)
        }
    );
}


// fin de login sur un succes
function _loginEndSuccess(method, obj, device) {
    // log
    // console.log(method, obj)
    // debug
    store.commit("setDebug", {
        method: method,
        obj: obj
    });

    // sécu
    if (!device) {
        console.error('_loginEndSuccess NO DEVICE')
        return
    }

    // debug
    console.log(obj)

    // sécu
    if (!obj.idToken) {
        console.error('no idToken')
        return
    }

    // demande identifiant
    _loginIdToken(obj.idToken, device)

}


// fin de login sur une erreur
function _loginEndError(method, msg) {
    // fin du chargement
    store.commit("setAuthLoading", false);
    // log
    // console.error(method, msg)
    // debug
    store.commit("setDebug", {
        method: method,
        error: msg
    });
}


// login depuis id token jwt (charge l'id token)
function _loginIdToken(idToken, device) {

    // sécu
    if (!idToken) {
        console.error('!idToken')
    }

    api.post('/auth/login_id_token', { idToken: idToken, platform: device.platform })
        .then(res => {
            if (res.data.jwt) {
                // enregistrement du jwt
                store.commit('setJwt', res.data.jwt);
            }
        })
        .catch(err => {
            console.error('_loginIdToken', err)
            // debug
            store.commit("setDebug", {
                method: '_loginIdToken',
                error: err
            });
        })
        .finally(() => {
            // fin du chargement
            store.commit("setAuthLoading", false);
        })

}
// logout
async function logout() {
    window.plugins.googleplus.logout(
        function (msg) {
            // do something useful instead of alerting
        }
    );
    return true
}

// module
export default {
    login: login,
    silentLogin: silentLogin,
    logout: logout
};
